export default "__VITE_ASSET__Cq7NFBJG__"